export default __webpack_public_path__ + "static/media/shop_vanillaJS.adfaf774.PNG";